module.exports = __webpack_public_path__ + "static/media/19ESCAP39.594c87d8.jpg";